import logWarningInDev from '../helpers/logWarningInDev';
function deprecationWarning(functionName) {
    logWarningInDev(true, `"${functionName}" has been deprecated.`);
}
/**
 * @deprecated
 */
export const trackProduct = (args) => (context) => {
    deprecationWarning('trackProduct');
    context.trackerRegistry.emit('trackProduct', args, context);
};
/**
 * @deprecated
 */
export const trackCartCheckout = (args) => (context) => {
    deprecationWarning('trackCartCheckout');
    context.trackerRegistry.emit('trackCartCheckout', args, context);
};
/**
 * @deprecated
 */
export const trackList = (args) => (context) => {
    deprecationWarning('trackList');
    context.trackerRegistry.emit('trackList', args, context);
};
/**
 * @deprecated
 */
export const trackPage = (args) => (context) => {
    deprecationWarning('trackPage');
    context.trackerRegistry.emit('trackPageView', args, context);
};
//# sourceMappingURL=deprecatedTracking.js.map